<template>
  <element>
    <AppBar :title="$t('partDetailsPage.title')" />
    <v-container>
      <h3>{{ part? part.name : '' }}</h3>
      <div class="d-flex justify-content-start">
        <small>{{ part ? part.oem_number : '' }}</small>
      </div>
      <div class="d-flex justify-content-start">
        <small>{{ part ? part.serial_number : '' }}</small>
      </div>
      <ImageGallery class="mt-3" :images="allImages" />
      <!-- <div class="desc-section">
        <small>{{ $t('partDetailsPage.description') }}</small>
        <p>{{ part.description }}</p>
      </div> -->
      <PartInfoTable class="mt-3" :info="part" ref="partInfo" />
      <LabelTextArea
        ref="notes"
        class="mt-3"
        :label="$t('partDetailsPage.notes')"
      ></LabelTextArea>
      <v-btn
        class="submit-btn"
        type="submit"
        height="45px"
        color="#033e8c"
        depressed
        block
        dark
        @click="update"
        >
        {{ $t('partDetailsPage.button') }}
      </v-btn>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import ImageGallery from "@/components/common/ImageGallery.vue"
import LabelTextArea from "@/components/common/LabelTextArea.vue"
import PartInfoTable from "@/components/part/PartInfoTable.vue"
import { DOCUMENT_TYPE_PART_PICTURE } from "@/constants"

export default {
  name: "PartDetailsPage",
  components: {
    AppBar,
    ImageGallery,
    LabelTextArea,
    PartInfoTable
  },
  data () {
    return {
      part: null,
      carId: null,
      images: null,
      documentTypes: [DOCUMENT_TYPE_PART_PICTURE]
    }
  },
  computed: {
    allImages: function () {
      if (this.part !== null) {
        return [this.part.img].concat(this.images)
      } else {
        return this.images
      }

    }
  },
  created() {
    const id = this.$route.params.id
    this.axios.get(`/Parts/get?part_id=${id}`, {}, { withCredentials: true })
    .then(response => {
      let part_ = response.data.data[0]
      this.$refs.notes.textValue = part_.notes
      this.carId = part_.car_id

      console.log("NOTES element", this.$refs.notes)

      this.axios.get(`/Cars/get/${this.carId}`)
      .then(response => {
        part_.vin = response.data.data.vin
        this.part = part_
      })
      .catch(error => {
        console.log("Failed retrieving car vin for part details", error)
      })
    })
    .catch(error => {
      console.log("Failed retrieving part details", error)
    })

    this.images = []

    this.documentTypes.forEach( type => {
      const url = `/Documents/get?document_type_id=${type}&data_id=${id}`
      this.axios.get(url, {}, { withCredentials: true })
      .then(response => {
        this.images = response.data.data.map(e => e.data_doc_raw)
      })
      .catch(error => {
        console.log("Failed retrieving car pictures.", error)
      })
    })
  },
  methods: {
    update() {
      const data = this.$refs.partInfo.details
      // td 202008232323 added taking care of notes (which is outside of the component PartInfoTable)
      const notesData = this.$refs.notes

      console.log("Modified data", data)
      // td 2020082325
      console.log("notes:", notesData.textValue);

      let formData = new FormData()

      formData.append('warehouse_location', data.warehouse_location != null ? data.warehouse_location : '')
      formData.append('part_condition', data.part_condition)
      formData.append('physical_location', data.physical_location)
      // this call generates a Cannot read property 'value' of undefined error
      formData.append('notes', notesData.textValue)

      this.axios.post(`/Parts/put/${this.part.part_id}`, formData, { withCredentials: true })
      .then(() => {
        console.log("Successfully updated part details")
      })
      .catch(error => {
        console.log("Failed updating part details", error)
      })
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

h3 {
  font-size: 2rem;
  font-weight: bold;
  text-align: left;
}

small {
  font-size: 0.9375rem;
  text-align: left;
}

.desc-section {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #c6cbd4;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 0.875rem;
}
</style>
